module.exports = __webpack_public_path__ + "img/invoice-alb.f5485825.svg";